import React from 'react';
import { AccountCircle, MoreVert } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useInfoAfiliado } from '../../../components/Afiliados/InfoAfiliadoProvider';

const TopMenu = ({ list }) => {
  const listMenu = list;
  const { infoAfiliado } = useInfoAfiliado();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = 'primary-search-account-menu';

  if (!listMenu) {
    return;
  }

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderTopList = listMenu.map((item) => {
    return (
      <MenuItem key={item.to} component={Link} to={item.to} onClick={handleMenuClose}>
        <ListItemIcon>{item.icon}</ListItemIcon>
        {item.label}
      </MenuItem>
    );
  });

  return (
    <Box>
      <IconButton
        id='top-menu'
        size='large'
        edge='end'
        aria-label='Menú de perfil de usuario.'
        aria-controls={menuId}
        aria-haspopup='true'
        onClick={handleProfileMenuOpen}
        color='inherit'
        sx={{ ml: { xs: 0, md: 2 } }}
      >
        <AccountCircle sx={{ display: { xs: 'none', md: 'flex' } }} />
        <MoreVert sx={{ display: { xs: 'flex', md: 'none' } }} />
      </IconButton>
      <Menu
        id={menuId}
        aria-haspopup
        anchorEl={anchorEl}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        keepMounted
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <Grid
          aria-label='Usuario actual:'
          // aria-haspopup='true'
          container
          flexDirection={'column'}
          flexWrap={'wrap'}
          alignItems={'center'}
          sx={{
            outline: 0,
            minHeight: 'auto',
            margin: 0,
            marginBottom: '16px',
            padding: 0,
          }}
        >
          <Grid item sx={{ padding: '6px 16px' }}>
            <Avatar sx={{ width: 50, height: 50 }} />
          </Grid>
          <Grid item sx={{ padding: '6px 16px' }}>
            <Typography variant='inherit' noWrap>
              {infoAfiliado?.personaFisica?.nombre || 'Cuenta'}
            </Typography>
          </Grid>
        </Grid>
        {/* <MenuItem component={Link} to='/perfil' key='perfil'>
          <ListItemIcon
            size='large'
            aria-label='Usuario actual:'
            aria-haspopup='true'
            color='inherit'
          >
            <AccountCircle />
          </ListItemIcon>
          <p>{infoAfiliado?.personaFisica?.nombre || 'Cuenta'}</p>
        </MenuItem> */}
        <Divider />
        {renderTopList}
      </Menu>
    </Box>
  );
};

export default TopMenu;
